import {defineStore} from "pinia";
import {ref} from "vue";
import {cache} from "../../lib/utils/storage";

type SearchRecord = {
    result: string,
    type: string,
    copyResult: boolean,
    thumbnailUrl: string,
    thumbnailWidth: number,
    thumbnailHeight: number,
    videoId: string,
    ref: string
}

type TrendingResponse = {
    trending: SearchRecord[]
}

export const useStore = defineStore("searchstore", () => {
    const query = ref("");
    const lastTerm = ref("")
    const trending = ref<SearchRecord[]>([]);
    const searchResults = ref<SearchRecord[]>([]);

    function fetchTrending(){
        const cachedData = cache("trl:trending")
        if (cachedData) {
            trending.value = cachedData as SearchRecord[];
            return;
        }
        fetch("/api/trending/", {
            credentials: "omit",
            headers: {
                'X-Requested-With': 'XMLHttpRequest',
            },
        }).then((response) => {
            if (response.status >= 200 && response.status < 300) {
                return response.json()
            }
            return Promise.reject(response)
        }).then((result: TrendingResponse) => {
            trending.value = result.trending;
            cache("trl:trending", result.trending, 60*60);
        }).catch((error) => {
            console.error(`Count not load trending searches, response: ${error.status}`);
        })
    }

    function fetchSearch(){
        const term = query.value.toString().trim()
        const params = new URLSearchParams()
        params.append("is_extended", "1");
        params.append("q", term);

        if (term.length >= 3 && term !== lastTerm.value){
            fetch("/api/autocomplete/?" + params.toString(), {
                credentials: "omit",
                headers: {
                    'X-Requested-With': 'XMLHttpRequest',
                },
            }).then((response) => {
                if (response.status >= 200 && response.status < 300) {
                    return response.json()
                }
                return Promise.reject(response)
            }).then((result) => {
                lastTerm.value = term;
                searchResults.value = result;
            }).catch((error) => {
                console.error(`Count not load autocomplete, response: ${error.status}`);
            })
        }else if (term.length === 0){
            lastTerm.value = term;
            searchResults.value = [];
        }
    }
    return {query, trending, searchResults, fetchTrending, fetchSearch}
})
